import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AppShell } from './components/layout/AppShell';
import { Landing } from './pages/Landing';
import { Dashboard } from './pages/Dashboard';
import { ServiceOrders } from './pages/ServiceOrders';
import { ServiceOrderDetail } from './pages/ServiceOrderDetail';
import { Clients } from './pages/Clients';
import { ClientDetail } from './pages/ClientDetail';
import { Vehicles } from './pages/Vehicles';
import { VehicleDetail } from './pages/VehicleDetail';
import { Inventory } from './pages/Inventory';
import { Financial } from './pages/Financial';
import { Schedule } from './pages/Schedule';
import { Login } from './pages/Login';
import { Onboarding } from './pages/Onboarding';
// Placeholders for other routes
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="flex h-full items-center justify-center" data-id="element-0">
    <h1 className="text-2xl font-bold text-muted-foreground" data-id="element-1">{title}</h1>
  </div>;
export function App() {
  return <ThemeProvider defaultTheme="dark" storageKey="garageflow-theme" data-id="element-2">
      <BrowserRouter data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Landing data-id="element-6" />} data-id="element-5" />
          <Route path="/login" element={<Login data-id="element-8" />} data-id="element-7" />
          <Route path="/onboarding" element={<Onboarding data-id="element-10" />} data-id="element-9" />

          <Route path="/app" element={<AppShell data-id="element-12" />} data-id="element-11">
            <Route index element={<Dashboard data-id="element-14" />} data-id="element-13" />
            <Route path="ordens" element={<ServiceOrders data-id="element-16" />} data-id="element-15" />
            <Route path="ordens/:id" element={<ServiceOrderDetail data-id="element-18" />} data-id="element-17" />
            <Route path="clientes" element={<Clients data-id="element-20" />} data-id="element-19" />
            <Route path="clientes/:id" element={<ClientDetail data-id="element-22" />} data-id="element-21" />
            <Route path="veiculos" element={<Vehicles data-id="element-24" />} data-id="element-23" />
            <Route path="veiculos/:id" element={<VehicleDetail data-id="element-26" />} data-id="element-25" />
            <Route path="estoque" element={<Inventory data-id="element-28" />} data-id="element-27" />
            <Route path="financeiro" element={<Financial data-id="element-30" />} data-id="element-29" />
            <Route path="agenda" element={<Schedule data-id="element-32" />} data-id="element-31" />
            <Route path="configuracoes" element={<Placeholder title="Configurações" data-id="element-34" />} data-id="element-33" />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>;
}